module.exports = __webpack_public_path__ + "static/media/community.7c6947f4.png";